import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { StoreContext } from "../store/StoreContext";

const AuthAdmin = ({ children }) => {
  const { isAdmin } = useContext(StoreContext);

  const location = useLocation();

  return !isAdmin ? (
    <Navigate to="/not-found" state={{ from: location }} replace />
  ) : (
    children
  );
};

export default AuthAdmin;
